import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


export default {
name: 'myCollect',
directives: {
TransferDom
},
components: {
Confirm
},
data () {
return {
list: [],
noData: false,
showConfirm: false,
activeItem: '',
activeIndex: '',
}
},
methods: {
getList () {
this.$request.post('/favorite/listFavoriteByUserId',{

}).then(data => {
if(data.code == 0){
this.list = [...data.obj]
if(this.list.length == 0){
this.noData = true
}else{
this.noData = false
}
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
cancelCollection (item, index) {
this.showConfirm = true
this.activeItem = item
this.activeIndex = index
},
goShop () {
this.$router.push({
path: '/shop'
})
},
onConfirm () {
this.$request.post('/favorite/deleteById',{
spuId: this.activeItem.spuId
}).then(data => {
if(data.code == 0){
this.getList()
this.$vux.toast.show({
type: 'success',
text: '已取消收藏'
})
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
detail (item, index) {
this.$router.push({
path: '/commodity',
query: {
id: item.spuId
}
})
},
buyNow (item, index) {
this.$request.post('/cart/buynow',{
skuId: item.skuId,
qty: 1,
zoom: 1
}).then(data => {
if(data.code == 0){
this.$router.push({
path: '/submitOrder',
query: {
cartType: 'cartdirect'
}
})
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
},
created () {
this.getList()
},
mounted() {

},
}



// WEBPACK FOOTER //
// ./src/views/myCollect/script.js